(function () {
  let pausePillSyncUntil = 0;


  function finishB2BLoading() {
  document.documentElement.classList.remove('b2b-route-loading');
  document.documentElement.classList.add('b2b-route-ready');
}

  function activateB2BMode() {
    document.documentElement.classList.add('b2b-florist-mode');

    if (document.body) {
      document.body.classList.add('b2b-florist-mode');
    }

    document.querySelectorAll('[data-b2b-section]').forEach(function (section) {
      const shopifySection = section.closest('.shopify-section');

      if (shopifySection) {
        shopifySection.classList.add('b2b-florist-section-host');

        if (section.classList.contains('b2b-header-section')) {
          shopifySection.classList.add('b2b-header-host');
        }

        if (section.classList.contains('b2b-pills-section')) {
          shopifySection.classList.add('b2b-pills-host');
        }

        if (section.classList.contains('b2b-catalog-section')) {
          shopifySection.classList.add('b2b-catalog-host');
        }

        if (section.classList.contains('b2b-bottom-nav-section')) {
          shopifySection.classList.add('b2b-bottom-nav-host');
        }

        if (section.classList.contains('b2b-cart-section')) {
          shopifySection.classList.add('b2b-cart-host');
        }
      }
    });

    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (!section.classList.contains('b2b-florist-section-host')) {
        section.classList.add('b2b-hide-section');
      }
    });
  }

  function updateStickyHeights() {
    const header = document.querySelector('.b2b-header-section');
    const pills = document.querySelector('.b2b-pills-section');

    const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const pillsHeight = pills ? Math.ceil(pills.getBoundingClientRect().height) : 0;

    if (document.body) {
      document.body.style.setProperty('--b2b-sticky-header-height', `${headerHeight}px`);
      document.body.style.setProperty('--b2b-sticky-pills-height', `${pillsHeight}px`);
      document.body.style.setProperty('--b2b-sticky-total-height', `${headerHeight + pillsHeight}px`);
    }
  }

  function getStickyOffset() {
    const header = document.querySelector('.b2b-header-section');
    const pills = document.querySelector('.b2b-pills-section');

    const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const pillsHeight = pills ? Math.ceil(pills.getBoundingClientRect().height) : 0;

    return headerHeight + pillsHeight + 18;
  }

  function scrollToAnchor(anchor) {
    if (!anchor) return;

    const target = document.getElementById(`b2b-${anchor}`);
    if (!target) return;

    updateStickyHeights();

    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const finalPosition = Math.max(0, targetPosition - getStickyOffset());

    window.scrollTo({
      top: finalPosition,
      behavior: 'smooth'
    });
  }

  function buildLocationSwitchUrl(rawUrl) {
    if (!rawUrl) return rawUrl;

    const url = new URL(rawUrl, window.location.origin);
    url.searchParams.set('return_to', '/pages/b2b');

    return url.toString();
  }

  function createGalleryModal() {
    if (document.querySelector('[data-b2b-gallery-modal]')) return;

    const modal = document.createElement('div');
    modal.className = 'b2b-gallery-modal';
    modal.setAttribute('data-b2b-gallery-modal', '');

    modal.innerHTML = `
      <div class="b2b-gallery-dialog" role="dialog" aria-modal="true">
        <div class="b2b-gallery-header">
          <strong data-b2b-gallery-title></strong>
          <button type="button" class="b2b-gallery-close" data-b2b-gallery-close aria-label="Close">×</button>
        </div>
        <div class="b2b-gallery-main">
          <img src="" alt="" data-b2b-gallery-main>
        </div>
        <div class="b2b-gallery-thumbs" data-b2b-gallery-thumbs></div>
      </div>
    `;

    document.body.appendChild(modal);
  }

  function openGallery(title, images) {
    createGalleryModal();

    const modal = document.querySelector('[data-b2b-gallery-modal]');
    const titleEl = modal.querySelector('[data-b2b-gallery-title]');
    const mainImage = modal.querySelector('[data-b2b-gallery-main]');
    const thumbs = modal.querySelector('[data-b2b-gallery-thumbs]');

    const cleanImages = images.filter(Boolean);

    if (!cleanImages.length) return;

    titleEl.textContent = title || '';
    mainImage.src = cleanImages[0];
    mainImage.alt = title || '';

    thumbs.innerHTML = '';

    cleanImages.forEach((src, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `b2b-gallery-thumb${index === 0 ? ' is-active' : ''}`;
      button.innerHTML = `<img src="${src}" alt="">`;

      button.addEventListener('click', function () {
        mainImage.src = src;

        thumbs.querySelectorAll('.b2b-gallery-thumb').forEach((thumb) => {
          thumb.classList.remove('is-active');
        });

        button.classList.add('is-active');
      });

      thumbs.appendChild(button);
    });

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeGallery() {
    const modal = document.querySelector('[data-b2b-gallery-modal]');
    if (!modal) return;

    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  activateB2BMode();

  const root =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  /*
    Klaviyo Back in Stock:
    - Use the Klaviyo Public API Key / Site ID only.
    - Do not use a private API key in this frontend file.
    - You can either replace the placeholder below or set window.B2B_KLAVIYO_PUBLIC_API_KEY before this script loads.
  */
  const KLAVIYO_BIS_REVISION = '2026-04-15';

  /*
    Put the Klaviyo Public API Key / Site ID here.
    This value is safe for frontend usage because it is Klaviyo's public company ID.
    Do NOT change KLAVIYO_PUBLIC_API_KEY_PLACEHOLDER below.
  */
  const B2B_KLAVIYO_PUBLIC_API_KEY = 'RP3Gea';
  const KLAVIYO_PUBLIC_API_KEY_PLACEHOLDER = 'PASTE_YOUR_KLAVIYO_PUBLIC_API_KEY_HERE';
  const KLAVIYO_PUBLIC_API_KEY_FALLBACK = B2B_KLAVIYO_PUBLIC_API_KEY;

  const endpoints = {
    cart: `${root}cart.js`,
    update: `${root}cart/update.js`,
    change: `${root}cart/change.js`,
    clear: `${root}cart/clear.js`
  };

  const b2bContext = document.querySelector('[data-b2b-context]');

  function getB2BKlaviyoPublicApiKey() {
    return String(
      window.B2B_KLAVIYO_PUBLIC_API_KEY ||
      document.documentElement.dataset.klaviyoCompanyId ||
      (b2bContext && b2bContext.dataset.klaviyoCompanyId) ||
      KLAVIYO_PUBLIC_API_KEY_FALLBACK ||
      ''
    ).trim();
  }

  function isMissingKlaviyoPublicApiKey(apiKey) {
    return (
      !apiKey ||
      apiKey === 'PASTE_YOUR_KLAVIYO_PUBLIC_API_KEY_HERE' ||
      apiKey.indexOf('PASTE_YOUR') !== -1
    );
  }
  const locationMenu = document.querySelector('[data-b2b-location-menu]');
  const locationTrigger = document.querySelector('[data-b2b-location-trigger]');
  const locationOptions = Array.from(document.querySelectorAll('[data-b2b-location-option]'));

  const searchInput = document.querySelector('[data-b2b-search]');
  const pillButtons = Array.from(document.querySelectorAll('[data-b2b-pill]'));
  const colorButtons = Array.from(document.querySelectorAll('[data-b2b-color-filter]'));
  const rows = Array.from(document.querySelectorAll('[data-b2b-product]'));
  const categorySections = Array.from(document.querySelectorAll('[data-b2b-category-section]'));
  function getB2BCartCounters() {
    return Array.from(document.querySelectorAll('[data-b2b-cart-count]'));
  }


  const cartPage = document.querySelector('[data-b2b-cart-page]');
  const cartLineCount = document.querySelector('[data-b2b-cart-lines]');
  const cartSubtotalExcludingVatEl = document.querySelector('[data-b2b-cart-subtotal-excluding-vat]');
  const cartSubtotalEl = document.querySelector('[data-b2b-cart-subtotal]');
  const cartVatEl = document.querySelector('[data-b2b-cart-vat]');
  const cartTotalEl = document.querySelector('[data-b2b-cart-total]');
  const cartCreditAfterEl = document.querySelector('[data-b2b-credit-after]');
const cartCreditWarningEl = document.querySelector('[data-b2b-credit-warning]');
const cartCheckoutButton = document.querySelector('[data-b2b-checkout-button]');
const b2bCheckoutForm = document.querySelector('[data-b2b-checkout-form]');

  let activeStockOnly = false;
  let activeColor = 'all';
  let activeColorCategory = 'all';
  let cartItemsByVariant = {};
  let cartLineKeysByVariant = {};

  /*
    Instant B2B cart mode:
    - UI quantity changes immediately on tap.
    - Shopify cart is synced quietly after the user pauses tapping.
    - Multiple product changes are batched into one cart/update.js request.
  */
  const b2bCartSyncDelay = 400;
  const b2bPendingStorageKey = 'sharbatly-b2b-pending-cart-updates-v6';
  const b2bLegacyPendingStorageKeys = [
    'sharbatly-b2b-pending-cart-updates-v5',
    'sharbatly-b2b-pending-cart-updates-v4',
    'sharbatly-b2b-pending-cart-updates-v3',
    'sharbatly-b2b-pending-cart-updates-v2'
  ];
  const b2bPendingMaxAgeMs = 2 * 60 * 1000;
  let pendingCartUpdates = {};
  let cartSyncTimer = null;
  let cartSyncPromise = null;
  let cartSyncErrorShown = false;
  let latestCartCache = null;
  let operationalSubtotalCents = 0;

  function toNumber(value, fallback) {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  }

  function isB2BBoxItem(item) {
    const handle = (item.handle || item.product_handle || '').toLowerCase();
    const title = (item.product_title || item.title || '').toLowerCase();

    return (
      title.includes('delivery carton') ||
      handle.includes('delivery-carton') ||
      handle.includes('shipping-carton') ||
      handle.includes('shipping-bag') ||
      handle.includes('sharbatly-club-delivery-carton')
    );
  }

  function getVisibleB2BCartCount(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce((total, item) => {
      if (isB2BBoxItem(item)) {
        return total;
      }

      return total + Number(item.quantity || 0);
    }, 0);
  }

  function updateB2BCartCounters(count) {
    const safeCount = Number(count || 0);

    getB2BCartCounters().forEach((counter) => {
      counter.textContent = String(safeCount);
      counter.hidden = false;
      counter.classList.toggle('has-items', safeCount > 0);
      counter.classList.toggle('is-visible', safeCount > 0);

      if (safeCount > 0) {
        counter.style.display = 'inline-flex';
        counter.style.visibility = 'visible';
        counter.style.opacity = '1';
      } else {
        counter.style.display = 'none';
        counter.style.visibility = 'hidden';
        counter.style.opacity = '0';
      }
    });
  }

  function normalizeManualQuantity(row, rawValue) {
    const min = toNumber(row.dataset.min, 1);
    const max = row.dataset.max ? toNumber(row.dataset.max, null) : null;
    const step = toNumber(row.dataset.step, 1);

    let quantity = parseInt(rawValue, 10);

    if (!Number.isFinite(quantity) || quantity < 0) {
      quantity = 0;
    }

    if (quantity > 0 && quantity < min) {
      quantity = min;
    }

    if (quantity > 0 && step > 1) {
      quantity = Math.ceil(quantity / step) * step;
    }

    if (max !== null && quantity > max) {
      quantity = max;
    }

    return quantity;
  }

  function formatB2BMoney(cents) {
    const currency = cartPage ? cartPage.dataset.currency || 'SAR' : 'SAR';
    const amount = Number(cents || 0) / 100;

    return `${currency} ${amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  const b2bLinePriceDivisor = cartPage && cartPage.dataset.productPricesExcludingVat === 'true'
    ? 1 + Number(cartPage.dataset.vatRate || 15) / 100
    : 1;

  function formatB2BLineMoney(cents) {
    return formatB2BMoney(Math.round(Number(cents || 0) / b2bLinePriceDivisor));
  }

  function updatePurchasedStemsForRow(row, quantity) {
    if (!row || !row.matches('[data-b2b-cart-line]')) return;

    const output = row.querySelector('[data-b2b-purchased-stems]');
    if (!output) return;

    const stemsPerBunch = Math.max(0, toNumber(row.dataset.stemsPerBunch, 0));
    const totalStems = Math.max(0, Number(quantity || 0)) * stemsPerBunch;
    const valueElement = output.querySelector('[data-b2b-purchased-stems-value]');
    const labelElement = output.querySelector('[data-b2b-purchased-stems-label]');
    const singularLabel = row.dataset.stemSingularLabel || 'stem';
    const pluralLabel = row.dataset.stemPluralLabel || 'stems';

    if (valueElement) {
      valueElement.textContent = String(totalStems);
    }

    if (labelElement) {
      labelElement.textContent = totalStems === 1 ? singularLabel : pluralLabel;
    }

    output.hidden = totalStems <= 0;
  }

  function updateOptimisticCartPage() {
    if (!cartPage) return;

    const cartLines = Array.from(document.querySelectorAll('[data-b2b-cart-line]'));
    let subtotal = Number(operationalSubtotalCents || 0);
    let visibleLineCount = 0;

    cartLines.forEach((line) => {
      const variantId = line.dataset.variantId;
      const input = line.querySelector('[data-b2b-qty]');
      const quantity = Math.max(
        0,
        Number(
          Object.prototype.hasOwnProperty.call(cartItemsByVariant, variantId)
            ? cartItemsByVariant[variantId]
            : input
              ? input.value
              : 0
        ) || 0
      );
      const unitPriceCents = Math.max(0, Number(line.dataset.unitPriceCents || 0));
      const lineTotalCents = quantity * unitPriceCents;
      const lineTotal = line.querySelector('[data-b2b-line-total]');

      if (lineTotal) {
        lineTotal.textContent = formatB2BLineMoney(lineTotalCents);
      }

      updatePurchasedStemsForRow(line, quantity);

      if (quantity > 0) {
        visibleLineCount += 1;
      }

      subtotal += lineTotalCents;
    });

    const vatRate = Number(cartPage.dataset.vatRate || 15);
    const subtotalExcludingVat = Math.round(subtotal / (1 + vatRate / 100));
    const vat = subtotal - subtotalExcludingVat;
    const total = subtotal;

    if (cartLineCount) {
      cartLineCount.textContent = String(visibleLineCount);
    }

    if (cartSubtotalExcludingVatEl) {
      cartSubtotalExcludingVatEl.textContent = formatB2BMoney(subtotalExcludingVat);
    }

    if (cartSubtotalEl) {
      cartSubtotalEl.textContent = formatB2BMoney(subtotal);
    }

    if (cartVatEl) {
      cartVatEl.textContent = formatB2BMoney(vat);
    }

    if (cartTotalEl) {
      cartTotalEl.textContent = formatB2BMoney(total);
    }

    document.dispatchEvent(
      new CustomEvent('b2b:cart:optimistic-changed', {
        detail: {
          subtotal: subtotal,
          vat: vat,
          total: total
        }
      })
    );
  }

  function updateB2BBoxStrip(boxCount) {
    const boxStrip = document.querySelector('[data-b2b-box-strip]');
    const boxMessage = document.querySelector('[data-b2b-box-message]');
    const singleLabel = cartPage ? cartPage.dataset.boxSingleLabel || 'Your order will be delivered in 1 box' : 'Your order will be delivered in 1 box';
    const multiBefore = cartPage ? cartPage.dataset.boxMultiBefore || 'Your order will be delivered in' : 'Your order will be delivered in';
    const multiAfter = cartPage ? cartPage.dataset.boxMultiAfter || 'boxes' : 'boxes';

    if (!boxStrip || !boxMessage) return;

    if (boxCount > 0) {
      boxStrip.style.display = 'flex';

      if (boxCount === 1) {
        boxMessage.textContent = singleLabel;
      } else {
        boxMessage.innerHTML = `${multiBefore} <b data-b2b-box-count>${boxCount}</b> ${multiAfter}`;
      }
    } else {
      boxStrip.style.display = 'none';
    }
  }

  function updateB2BCartPage(cart) {
    if (!cartPage) return;

    const vatRate = Number(cartPage.dataset.vatRate || 15);
    const subtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
    const subtotalExcludingVat = Math.round(subtotal / (1 + vatRate / 100));
    const vat = subtotal - subtotalExcludingVat;
    const total = Number(cart.total_price ?? subtotal);

    const visibleItems = cart.items.filter((item) => !isB2BBoxItem(item));

    const boxCount = cart.items.reduce((sum, item) => {
      return sum + (isB2BBoxItem(item) ? item.quantity : 0);
    }, 0);

    updateB2BBoxStrip(boxCount);

    const activeVariantIds = visibleItems.map((item) => String(item.variant_id));

    document.querySelectorAll('[data-b2b-cart-line]').forEach((line) => {
      const variantId = line.dataset.variantId;

      if (!activeVariantIds.includes(String(variantId))) {
        line.remove();
      }
    });

    visibleItems.forEach((item) => {
      const row = document.querySelector(
        `[data-b2b-cart-line][data-variant-id="${item.variant_id}"]`
      );
      if (!row) return;
      const lineTotal = row.querySelector('[data-b2b-line-total]');
      const unitPrice = row.querySelector('[data-b2b-unit-price]');
      const unitPriceCents = Number(item.final_price ?? item.price ?? 0);
      row.dataset.unitPriceCents = String(unitPriceCents);

      if (unitPrice) {
        unitPrice.textContent = (Math.round(unitPriceCents / b2bLinePriceDivisor) / 100).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      if (lineTotal) {
        lineTotal.textContent = formatB2BLineMoney(item.final_line_price ?? item.line_price ?? 0);
      }
    });

    if (cartLineCount) {
      cartLineCount.textContent = visibleItems.length;
    }

    if (cartSubtotalExcludingVatEl) {
      cartSubtotalExcludingVatEl.textContent = formatB2BMoney(subtotalExcludingVat);
    }

    if (cartSubtotalEl) {
      cartSubtotalEl.textContent = formatB2BMoney(subtotal);
    }

    if (cartVatEl) {
      cartVatEl.textContent = formatB2BMoney(vat);
    }

    if (cartTotalEl) {
      cartTotalEl.textContent = formatB2BMoney(total);
    }

    const creditControlEnabled = cartPage.dataset.creditControlEnabled === 'true';
    const creditStatus = String(cartPage.dataset.creditStatus || 'active').toLowerCase();
    const creditAvailableCents = Number(cartPage.dataset.creditAvailableCents || 0);
    const creditOverdueCents = Number(cartPage.dataset.creditOverdueCents || 0);

    const creditAvailableAfterCents = creditAvailableCents - total;

    const isCreditBlocked =
      creditControlEnabled &&
      (
        creditStatus !== 'active' ||
        creditOverdueCents > 0 ||
        creditAvailableAfterCents < 0
      );

    if (cartCreditAfterEl) {
      cartCreditAfterEl.textContent = formatB2BMoney(Math.max(creditAvailableAfterCents, 0));
    }

    if (cartCreditWarningEl) {
      if (isCreditBlocked) {
        if (creditStatus !== 'active') {
          cartCreditWarningEl.textContent =
            cartPage.dataset.creditOnHoldMessage || 'This credit account is currently on hold.';
        } else if (creditOverdueCents > 0) {
          cartCreditWarningEl.textContent =
            cartPage.dataset.creditOverdueMessage || 'There is an overdue balance.';
        } else {
          cartCreditWarningEl.textContent =
            cartPage.dataset.creditInsufficientMessage || 'This order exceeds the available credit.';
        }

        cartCreditWarningEl.classList.remove('is-hidden');
      } else {
        cartCreditWarningEl.classList.add('is-hidden');
      }
    }

    if (cartCheckoutButton) {
      cartCheckoutButton.disabled = isCreditBlocked;
    }

    if (visibleItems.length === 0) {
      const existingVisibleLines = document.querySelectorAll('[data-b2b-cart-line]');

      if (existingVisibleLines.length > 0) {
        window.location.reload();
        return;
      }
    }
  }

  async function getCart() {
    const response = await fetch(endpoints.cart, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  }

  async function clearCart() {
    const response = await fetch(endpoints.clear, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to clear cart');
    }

    return response.json();
  }

  async function addItemsToCart(items) {
  const response = await fetch(`${root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.description || data.message || 'Unable to add items to cart');
  }

  return data;
}

function prepareReorderItems(rawItems) {
  const skipped = [];
  const adjusted = [];

  const items = rawItems
    .map((item) => {
      const requestedQty = Number(item.quantity || 0);
      const inventoryQty = Number(item.inventoryQuantity || 0);
      const inventoryPolicy = String(item.inventoryPolicy || '');
      const inventoryManagement = String(item.inventoryManagement || '');
      const available = item.available === true || item.available === 'true';
      const hasExplicitMaxQuantity =
        item.maxQuantity !== null &&
        item.maxQuantity !== undefined &&
        item.maxQuantity !== '';
      const parsedMaxQuantity = hasExplicitMaxQuantity
        ? Number(item.maxQuantity)
        : null;
      const maxQuantity =
        parsedMaxQuantity !== null && Number.isFinite(parsedMaxQuantity)
          ? Math.max(0, parsedMaxQuantity)
          : null;
      const inventoryMaxQuantity =
        inventoryManagement &&
        inventoryPolicy === 'deny' &&
        inventoryQty >= 0
          ? inventoryQty
          : null;
      const effectiveMaxQuantity =
        maxQuantity !== null && inventoryMaxQuantity !== null
          ? Math.min(maxQuantity, inventoryMaxQuantity)
          : maxQuantity !== null
            ? maxQuantity
            : inventoryMaxQuantity;

      if (!item.id || requestedQty <= 0) {
        return null;
      }

      if (!available || effectiveMaxQuantity === 0) {
        skipped.push(item.title || item.id);
        return null;
      }

      let finalQty = requestedQty;

      if (effectiveMaxQuantity !== null && requestedQty > effectiveMaxQuantity) {
        finalQty = effectiveMaxQuantity;
        adjusted.push(item.title || item.id);
      }

      if (finalQty <= 0) {
        skipped.push(item.title || item.id);
        return null;
      }

      return {
        id: Number(item.id),
        quantity: finalQty
      };
    })
    .filter(Boolean);

  return {
    items,
    skipped,
    adjusted
  };
}

async function handleReorder(button) {
  let rawItems = [];

  try {
    rawItems = JSON.parse(button.dataset.reorderItems || '[]');
  } catch (error) {
    alert('Could not read this order.');
    return;
  }

  const prepared = prepareReorderItems(rawItems);

  if (!prepared.items.length) {
    alert('None of the items from this order are currently available for reorder.');
    return;
  }

  const confirmed = window.confirm(
    'This will replace your current cart with the available items from this order. Continue?'
  );

  if (!confirmed) return;

  button.classList.add('is-loading');
  button.disabled = true;

  try {
    await clearCart();
    await addItemsToCart(prepared.items);
    await syncB2BCartAttributes();

    let message = '';

    if (prepared.adjusted.length) {
      message += 'Some quantities were adjusted based on available inventory.\n';
    }

    if (prepared.skipped.length) {
      message += 'Some unavailable items were skipped.';
    }

    if (message) {
      alert(message);
    }

    window.location.href = `${root}cart`;
  } catch (error) {
    alert(error.message || 'Could not reorder this order.');
  } finally {
    button.classList.remove('is-loading');
    button.disabled = false;
  }
}

  function getCartQuantityForVariant(cart, variantId) {
    const targetVariantId = String(variantId);

    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce((total, item) => {
      if (String(item.variant_id) === targetVariantId) {
        return total + Number(item.quantity || 0);
      }

      return total;
    }, 0);
  }

  async function changeCartLineQuantity(lineId, quantity) {
    const response = await fetch(endpoints.change, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineId,
        quantity: Number(quantity || 0)
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Unable to change cart quantity');
    }

    return data;
  }

  function getCartLineKeysForVariant(cart, variantId) {
    const targetVariantId = String(variantId);

    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    return cart.items
      .filter((item) => String(item.variant_id) === targetVariantId)
      .map((item) => item.key || String(item.variant_id))
      .filter(Boolean);
  }

  async function changeCartQuantity(variantId, quantity) {
    const lineKey = cartLineKeysByVariant[variantId] || cartLineKeysByVariant[String(variantId)];
    const lineId = lineKey || Number(variantId);

    return changeCartLineQuantity(lineId, quantity);
  }

  async function applyCartQuantityStrictly(variantId, requestedQty, cart) {
    let latestCart = cart || (await getCart());
    const targetQty = Math.max(0, Number(requestedQty || 0));
    let actualQty = getCartQuantityForVariant(latestCart, variantId);

    if (actualQty === targetQty) {
      return latestCart;
    }

    if (targetQty > actualQty) {
      const addQty = targetQty - actualQty;

      await addItemsToCart([
        {
          id: Number(variantId),
          quantity: addQty
        }
      ]);

      latestCart = await getCart();
      actualQty = getCartQuantityForVariant(latestCart, variantId);
    }

    if (targetQty < actualQty) {
      const lineKeys = getCartLineKeysForVariant(latestCart, variantId);

      if (targetQty === 0 && lineKeys.length > 1) {
        for (const lineKey of lineKeys) {
          latestCart = await changeCartLineQuantity(lineKey, 0);
        }
      } else {
        const lineId = lineKeys[0] || Number(variantId);
        latestCart = await changeCartLineQuantity(lineId, targetQty);
      }

      actualQty = getCartQuantityForVariant(latestCart, variantId);
    }

    if (actualQty !== targetQty) {
      latestCart = await updateCartQuantity(variantId, targetQty);
      actualQty = getCartQuantityForVariant(latestCart, variantId);
    }

    if (actualQty !== targetQty) {
      throw new Error('Shopify did not save the latest cart quantity. Please try again.');
    }

    return latestCart;
  }

  async function ensureCartQuantitiesApplied(cart, updates) {
    let latestCart = cart || (await getCart());

    for (const variantId of Object.keys(updates || {})) {
      latestCart = await applyCartQuantityStrictly(variantId, updates[variantId], latestCart);
    }

    return latestCart;
  }

  function setRowsPendingForUpdates(updates, isPending) {
    rows.forEach((row) => {
      if (Object.prototype.hasOwnProperty.call(updates || {}, row.dataset.variantId)) {
        row.classList.toggle('is-pending', Boolean(isPending));
        row.classList.remove('is-loading');
      }
    });
  }

  function removeSyncedStoredUpdates(updates) {
    const stored = readStoredPendingCartUpdates();

    Object.keys(updates || {}).forEach((variantId) => {
      if (Number(stored[variantId]) === Number(updates[variantId])) {
        delete stored[variantId];
      }
    });

    writeStoredPendingCartUpdates(stored);
  }

  async function flushPendingCartUpdates() {
    if (cartSyncTimer) {
      window.clearTimeout(cartSyncTimer);
      cartSyncTimer = null;
    }

    if (cartSyncPromise) {
      return cartSyncPromise;
    }

    cartSyncPromise = (async function () {
      let latestCart = null;

      try {
        while (true) {
          mergeStoredPendingCartUpdates();

          const updates = {
            ...readStoredPendingCartUpdates(),
            ...pendingCartUpdates
          };

          pendingCartUpdates = {};

          if (!Object.keys(updates).length) {
            break;
          }

          writeStoredPendingCartUpdates(updates);
          setRowsPendingForUpdates(updates, true);

          latestCart = await updateCartQuantities(updates);

          const mismatchedUpdates = {};

          Object.keys(updates).forEach((variantId) => {
            const requestedQuantity = Number(updates[variantId] || 0);
            const actualQuantity = getCartQuantityForVariant(latestCart, variantId);

            if (actualQuantity !== requestedQuantity) {
              mismatchedUpdates[variantId] = requestedQuantity;
            }
          });

          if (Object.keys(mismatchedUpdates).length) {
            latestCart = await ensureCartQuantitiesApplied(
              latestCart,
              mismatchedUpdates
            );
          }

          removeSyncedStoredUpdates(updates);
          setRowsPendingForUpdates(updates, false);

          cartSyncErrorShown = false;
          indexCart(latestCart);

          const stillHasPending =
            Object.keys(pendingCartUpdates).length > 0 ||
            Object.keys(readStoredPendingCartUpdates()).length > 0;

          if (!stillHasPending) {
            break;
          }
        }

        return latestCart || getCart();
      } catch (error) {
        console.warn(error);

        if (!cartSyncErrorShown) {
          cartSyncErrorShown = true;
          alert(error.message || 'Could not update cart quantity.');
        }

        await refreshCart();
        throw error;
      } finally {
        cartSyncPromise = null;
      }
    })();

    return cartSyncPromise;
  }

  async function forceFlushPendingCartUpdates() {
    if (cartSyncTimer) {
      window.clearTimeout(cartSyncTimer);
      cartSyncTimer = null;
    }

    mergeStoredPendingCartUpdates();

    if (!Object.keys(pendingCartUpdates).length && !Object.keys(readStoredPendingCartUpdates()).length) {
      if (cartSyncPromise) {
        return cartSyncPromise;
      }

      return latestCartCache
        ? Promise.resolve(latestCartCache)
        : getCart();
    }

    return flushPendingCartUpdates();
  }

  async function updateCartPayload(payload) {
    const response = await fetch(endpoints.update, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload || {})
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Unable to update cart');
    }

    return data;
  }

  async function updateCartQuantities(updates) {
    return updateCartPayload({
      updates: updates
    });
  }

  async function updateCartQuantity(variantId, quantity) {
    return updateCartQuantities({
      [variantId]: quantity
    });
  }

  async function updateCartAttributes(attributes) {
    return updateCartPayload({
      attributes: attributes
    });
  }

  function getB2BAttributes() {
    if (!b2bContext || b2bContext.dataset.b2bReady !== 'true') {
      return null;
    }

    return {
  'B2B Company ID': b2bContext.dataset.companyId || '',
  'B2B Company Location ID': b2bContext.dataset.companyLocationId || '',
  'B2B Company': b2bContext.dataset.company || '',
  'B2B Company Location': b2bContext.dataset.companyLocation || '',
  'B2B Delivery City': b2bContext.dataset.deliveryCity || '',
  'B2B Warehouse City': b2bContext.dataset.warehouseCity || ''
};
  }

  function getCheckoutFormAttributes(form) {
    const attributes = {};

    if (!form) {
      return attributes;
    }

    form.querySelectorAll('[name^="attributes["]').forEach((input) => {
      const match = String(input.name || '').match(/^attributes\[(.+)\]$/);

      if (match) {
        attributes[match[1]] = input.value || '';
      }
    });

    return attributes;
  }

  async function saveCartForCheckout(attributes) {
    if (cartSyncTimer) {
      window.clearTimeout(cartSyncTimer);
      cartSyncTimer = null;
    }

    if (cartSyncPromise) {
      await cartSyncPromise;
    }

    mergeStoredPendingCartUpdates();

    const updates = {
      ...readStoredPendingCartUpdates(),
      ...pendingCartUpdates
    };

    pendingCartUpdates = {};

    const payload = {
      attributes: attributes
    };

    if (Object.keys(updates).length) {
      payload.updates = updates;
      writeStoredPendingCartUpdates(updates);
      setRowsPendingForUpdates(updates, true);
    }

    try {
      const cart = await updateCartPayload(payload);

      if (Object.keys(updates).length) {
        removeSyncedStoredUpdates(updates);
        setRowsPendingForUpdates(updates, false);
      }

      indexCart(cart);
      return cart;
    } catch (error) {
      pendingCartUpdates = {
        ...updates,
        ...pendingCartUpdates
      };

      writeStoredPendingCartUpdates({
        ...updates,
        ...pendingCartUpdates
      });

      setRowsPendingForUpdates(updates, true);
      throw error;
    }
  }

  async function syncB2BCartAttributes() {
    const attributes = getB2BAttributes();

    if (!attributes) return;

    try {
      await updateCartAttributes(attributes);
    } catch (error) {
      console.warn(error);
    }
  }

  function indexCart(cart) {
    latestCartCache = cart;
    operationalSubtotalCents = Array.isArray(cart && cart.items)
      ? cart.items.reduce((sum, item) => {
          if (!isB2BBoxItem(item)) return sum;
          return sum + Number(item.final_line_price || item.line_price || 0);
        }, 0)
      : 0;

    cartItemsByVariant = {};
    cartLineKeysByVariant = {};

    cart.items.forEach((item) => {
      cartItemsByVariant[item.variant_id] = item.quantity;

      if (item.key) {
        cartLineKeysByVariant[item.variant_id] = item.key;
      }
    });

    Object.keys(pendingCartUpdates).forEach((variantId) => {
      cartItemsByVariant[variantId] = pendingCartUpdates[variantId];
    });

    const visibleItemCount = getVisibleB2BCartCount(cart);
    updateB2BCartCounters(visibleItemCount);

    rows.forEach((row) => {
      const variantId = row.dataset.variantId;
      const input = row.querySelector('[data-b2b-qty]');

      if (input && document.activeElement !== input) {
        input.value = cartItemsByVariant[variantId] || 0;
      }

      updatePurchasedStemsForRow(row, cartItemsByVariant[variantId] || 0);

      if (!Object.prototype.hasOwnProperty.call(pendingCartUpdates, variantId)) {
        row.classList.remove('is-pending');
        row.classList.remove('is-loading');
      }
    });

    updateB2BCartPage(cart);

    document.dispatchEvent(
      new CustomEvent('b2b:cart:state-updated', {
        detail: {
          cart: cart
        }
      })
    );
  }

  function clearLegacyPendingCartUpdates() {
    try {
      (b2bLegacyPendingStorageKeys || []).forEach((storageKey) => {
        window.localStorage.removeItem(storageKey);
      });
    } catch (error) {
      console.warn(error);
    }
  }

  function cleanPendingCartUpdates(updates) {
    const clean = {};

    Object.keys(updates || {}).forEach((variantId) => {
      const quantity = Number(updates[variantId]);

      if (variantId && Number.isFinite(quantity) && quantity >= 0) {
        clean[variantId] = quantity;
      }
    });

    return clean;
  }

  function readStoredPendingCartUpdates() {
    try {
      clearLegacyPendingCartUpdates();

      const raw = window.localStorage.getItem(b2bPendingStorageKey);
      if (!raw) return {};

      const parsed = JSON.parse(raw) || {};
      const timestamp = Number(parsed.__ts || 0);
      const updates = parsed.updates || {};

      if (!timestamp || Date.now() - timestamp > b2bPendingMaxAgeMs) {
        window.localStorage.removeItem(b2bPendingStorageKey);
        return {};
      }

      return cleanPendingCartUpdates(updates);
    } catch (error) {
      try {
        window.localStorage.removeItem(b2bPendingStorageKey);
      } catch (storageError) {
        console.warn(storageError);
      }

      return {};
    }
  }

  function writeStoredPendingCartUpdates(updates) {
    try {
      clearLegacyPendingCartUpdates();

      const clean = cleanPendingCartUpdates(updates);

      if (Object.keys(clean).length) {
        window.localStorage.setItem(
          b2bPendingStorageKey,
          JSON.stringify({
            __b2bPendingCartUpdates: true,
            __ts: Date.now(),
            updates: clean
          })
        );
      } else {
        window.localStorage.removeItem(b2bPendingStorageKey);
      }
    } catch (error) {
      console.warn(error);
    }
  }

  function mergeStoredPendingCartUpdates() {
    const stored = readStoredPendingCartUpdates();

    if (!Object.keys(stored).length) {
      return false;
    }

    pendingCartUpdates = {
      ...stored,
      ...pendingCartUpdates
    };

    rows.forEach((row) => {
      const variantId = row.dataset.variantId;

      if (Object.prototype.hasOwnProperty.call(pendingCartUpdates, variantId)) {
        const quantity = Number(pendingCartUpdates[variantId] || 0);
        const input = row.querySelector('[data-b2b-qty]');

        cartItemsByVariant[variantId] = quantity;

        if (input && document.activeElement !== input) {
          input.value = quantity;
        }

        row.classList.add('is-pending');
        row.classList.remove('is-loading');
      }
    });

    updateOptimisticCartCounter();
    return true;
  }

  function updateOptimisticCartCounter() {
    const visibleItemCount = rows.reduce((total, row) => {
      const variantId = row.dataset.variantId;
      return total + Number(cartItemsByVariant[variantId] || 0);
    }, 0);

    updateB2BCartCounters(visibleItemCount);
  }

  function setRowQuantityInstantly(row, quantity) {
    const variantId = row.dataset.variantId;
    const input = row.querySelector('[data-b2b-qty]');

    cartItemsByVariant[variantId] = quantity;

    if (input) {
      input.value = quantity;
    }

    row.classList.add('is-pending');
    row.classList.remove('is-loading');

    updatePurchasedStemsForRow(row, quantity);
    updateOptimisticCartCounter();
    updateOptimisticCartPage();
  }

  function hasPendingCartUpdates() {
    return Object.keys(pendingCartUpdates).length > 0 || Boolean(cartSyncPromise);
  }

  function queueCartQuantityUpdate(variantId, quantity, delay) {
    const stored = readStoredPendingCartUpdates();

    pendingCartUpdates[variantId] = quantity;
    stored[variantId] = quantity;
    writeStoredPendingCartUpdates({
      ...stored,
      ...pendingCartUpdates
    });

    if (cartSyncTimer) {
      window.clearTimeout(cartSyncTimer);
    }

    cartSyncTimer = window.setTimeout(function () {
      flushPendingCartUpdates();
    }, typeof delay === 'number' ? delay : b2bCartSyncDelay);
  }

  async function refreshCart() {
    try {
      const cart = await getCart();
      indexCart(cart);
      return cart;
    } catch (error) {
      console.warn(error);
      return null;
    }
  }

  function getNextQty(row, direction) {
    const variantId = row.dataset.variantId;
    const currentQty = cartItemsByVariant[variantId] || 0;

    const min = toNumber(row.dataset.min, 1);
    const max = row.dataset.max ? toNumber(row.dataset.max, null) : null;
    const step = toNumber(row.dataset.step, 1);

    let nextQty;

    if (direction === 'plus') {
      if (currentQty === 0) {
        nextQty = Math.max(min, step);
      } else {
        nextQty = currentQty + step;
      }

      if (max !== null && nextQty > max) {
        nextQty = max;
      }
    } else {
      nextQty = currentQty - step;

      if (nextQty < min) {
        nextQty = 0;
      }
    }

    return Math.max(0, nextQty);
  }

  function handleStepper(row, direction) {
    const variantId = row.dataset.variantId;
    const nextQty = getNextQty(row, direction);

    setRowQuantityInstantly(row, nextQty);
    queueCartQuantityUpdate(variantId, nextQty, b2bCartSyncDelay);
  }

  function handleManualQuantity(input) {
    const row = input.closest('[data-b2b-product]');
    if (!row) return;

    const variantId = row.dataset.variantId;
    const nextQty = normalizeManualQuantity(row, input.value);

    input.value = nextQty;

    if (nextQty === Number(cartItemsByVariant[variantId] || 0)) return;

    const currentQty = Number(cartItemsByVariant[variantId] || 0);

    setRowQuantityInstantly(row, nextQty);
    queueCartQuantityUpdate(variantId, nextQty, b2bCartSyncDelay);
  }

  function rowMatchesFilters(row, query) {
    const searchText = (row.dataset.search || '').toLowerCase();
    const available = row.dataset.available === 'true';
    const color = (row.dataset.color || '').toLowerCase();
    const categoryAnchor = row.dataset.categoryAnchor || '';

    const matchesSearch = !query || searchText.includes(query);
    const matchesStock = !activeStockOnly || available;

    const matchesColor =
      activeColor === 'all' ||
      (categoryAnchor === activeColorCategory && color === activeColor);

    return matchesSearch && matchesStock && matchesColor;
  }

  function updateVisibleCategories() {
    categorySections.forEach((section) => {
      const categoryAnchor = section.dataset.categoryAnchor || '';

      const hasVisibleProducts = rows.some((row) => {
        return row.dataset.categoryAnchor === categoryAnchor && !row.classList.contains('is-hidden');
      });

      section.classList.toggle('is-hidden', !hasVisibleProducts);
    });
  }

  function applyFilters() {
    const query = searchInput ? searchInput.value.trim().toLowerCase() : '';

    rows.forEach((row) => {
      row.classList.toggle('is-hidden', !rowMatchesFilters(row, query));
    });

    updateVisibleCategories();
    updateStickyHeights();
  }

  function resetColorFilter() {
    activeColor = 'all';
    activeColorCategory = 'all';

    colorButtons.forEach((button) => {
      button.classList.remove('is-active');
    });
  }

  function setActivePill(button) {
    pillButtons.forEach((pill) => {
      pill.classList.remove('is-active');

      if (typeof pill.blur === 'function') {
        pill.blur();
      }
    });

    button.classList.add('is-active');

    if (typeof button.blur === 'function') {
      button.blur();
    }
  }

  function setActivePillByAnchor(anchor) {
    if (!anchor) return;

    const matchingPill = pillButtons.find((pill) => {
      return pill.dataset.b2bPillAction === 'scroll' && pill.dataset.b2bPillTarget === anchor;
    });

    if (!matchingPill) return;

    pillButtons.forEach((pill) => {
      pill.classList.remove('is-active');

      if (typeof pill.blur === 'function') {
        pill.blur();
      }
    });

    matchingPill.classList.add('is-active');
  }

  function syncActivePillSimple() {
    if (Date.now() < pausePillSyncUntil) return;
    if (!categorySections.length || !pillButtons.length) return;

    const stickyOffset = getStickyOffset();
    const checkPosition = window.scrollY + stickyOffset + 80;
    let activeAnchor = '';

    categorySections.forEach((section) => {
      if (section.classList.contains('is-hidden')) return;

      const top = section.offsetTop;
      const bottom = top + section.offsetHeight;

      if (checkPosition >= top && checkPosition < bottom) {
        activeAnchor = section.dataset.categoryAnchor || '';
      }
    });

    if (activeAnchor) {
      setActivePillByAnchor(activeAnchor);
    }
  }

  function scrollToFirstVisibleCategory() {
    const firstVisibleCategory = categorySections.find((section) => {
      return !section.classList.contains('is-hidden');
    });

    if (!firstVisibleCategory) return;

    const anchor = firstVisibleCategory.dataset.categoryAnchor;
    scrollToAnchor(anchor);
  }

  function closeLocationMenu() {
    if (!locationMenu) return;

    locationMenu.classList.remove('is-open');

    if (locationTrigger) {
      locationTrigger.setAttribute('aria-expanded', 'false');
    }
  }

  function openLocationMenu() {
    if (!locationMenu) return;

    locationMenu.classList.add('is-open');

    if (locationTrigger) {
      locationTrigger.setAttribute('aria-expanded', 'true');
    }
  }

  if (locationTrigger && locationMenu) {
    locationTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (locationMenu.classList.contains('is-open')) {
        closeLocationMenu();
      } else {
        openLocationMenu();
      }
    });
  }

  locationOptions.forEach((option) => {
    option.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();

      const nextUrl = option.dataset.locationUrl;
      const confirmMessage = locationMenu ? locationMenu.dataset.confirmMessage : '';

      if (!nextUrl || option.classList.contains('is-current')) {
        closeLocationMenu();
        return;
      }

      const confirmed = window.confirm(
        confirmMessage || 'Changing location will clear the B2B cart. Continue?'
      );

      if (!confirmed) {
        closeLocationMenu();
        return;
      }

      locationOptions.forEach((button) => {
        button.disabled = true;
      });

      option.classList.add('is-loading');

      try {
        await clearCart();
      } catch (error) {
        console.warn(error);
      }

      window.location.href = buildLocationSwitchUrl(nextUrl);
    });
  });

  function getKlaviyoButtonLabel(button, key, fallback) {
    return button.dataset[key] || fallback;
  }

  function setKlaviyoReminderState(button, state, detailMessage) {
    if (!button) return;

    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = button.textContent.trim();
    }

    button.classList.remove('is-loading', 'is-success', 'is-error');

    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = getKlaviyoButtonLabel(button, 'loadingLabel', 'Subscribing...');
      return;
    }

    if (state === 'success') {
      button.disabled = true;
      button.classList.add('is-success');
      button.textContent = getKlaviyoButtonLabel(button, 'successLabel', 'Reminder set');
      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.classList.add('is-error');
      button.textContent = getKlaviyoButtonLabel(button, 'errorLabel', 'Could not set reminder');

      if (detailMessage) {
        button.setAttribute('title', detailMessage);
        window.alert(detailMessage);
      }

      window.setTimeout(function () {
        button.classList.remove('is-error');
        button.textContent = button.dataset.originalLabel || 'Remind me';
      }, 2500);

      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.originalLabel || 'Remind me';
  }

  function getKlaviyoApiErrorMessage(response, errorPayload, fallbackText) {
    let detail = '';

    if (errorPayload && Array.isArray(errorPayload.errors) && errorPayload.errors.length) {
      const firstError = errorPayload.errors[0];
      detail = firstError.detail || firstError.title || firstError.code || '';
    }

    if (!detail && fallbackText) {
      detail = String(fallbackText);
    }

    if (!detail) {
      detail = `Klaviyo request failed with status ${response ? response.status : 'unknown'}.`;
    }

    const lowerDetail = detail.toLowerCase();

    if (lowerDetail.includes('invalid company id')) {
      return 'Klaviyo error: Invalid company ID. Use the Klaviyo public API key / Site ID, not the private API key.';
    }

    if (lowerDetail.includes('variant') && (lowerDetail.includes('not found') || lowerDetail.includes('does not exist'))) {
      return 'Klaviyo error: Variant was not found in Klaviyo catalog. Confirm this Shopify variant is synced to Klaviyo and use the Shopify variant ID, not product ID.';
    }

    if (lowerDetail.includes('invalid email')) {
      return 'Klaviyo error: Customer email address is invalid or missing.';
    }

    if (lowerDetail.includes('revision')) {
      return `Klaviyo error: API revision issue. Current script uses revision ${KLAVIYO_BIS_REVISION}. Details: ${detail}`;
    }

    return `Klaviyo Back in Stock error: ${detail}`;
  }

  function isKlaviyoAlreadySubscribedError(errorPayload, fallbackText) {
    const details = [];

    if (fallbackText) {
      details.push(String(fallbackText));
    }

    if (errorPayload && Array.isArray(errorPayload.errors)) {
      errorPayload.errors.forEach((error) => {
        if (error && error.detail) details.push(String(error.detail));
        if (error && error.title) details.push(String(error.title));
        if (error && error.code) details.push(String(error.code));
      });
    }

    const joined = details.join(' ').toLowerCase();

    return (
      joined.includes('already') ||
      joined.includes('duplicate') ||
      joined.includes('subscribed') ||
      joined.includes('exists')
    );
  }

  async function subscribeToKlaviyoBackInStock(button) {
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    const customerEmail = button.dataset.customerEmail;
    const apiKey = getB2BKlaviyoPublicApiKey();

    if (isMissingKlaviyoPublicApiKey(apiKey)) {
      console.warn('Missing Klaviyo public API key / Site ID for B2B Back in Stock.');
      setKlaviyoReminderState(button, 'error', 'Missing Klaviyo public API key / Site ID.');
      return;
    }

    if (!variantId) {
      console.warn('Missing Shopify variant ID for Klaviyo Back in Stock.');
      setKlaviyoReminderState(button, 'error', 'Missing Shopify variant ID on the Remind me button. Check catalog.liquid data-variant-id.');
      return;
    }

    if (!customerEmail) {
      alert(getKlaviyoButtonLabel(button, 'missingEmailLabel', 'Customer email is missing'));
      setKlaviyoReminderState(button, 'error');
      return;
    }

    setKlaviyoReminderState(button, 'loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: customerEmail
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(apiKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
            revision: KLAVIYO_BIS_REVISION
          },
          body: JSON.stringify(payload)
        }
      );

      if (response.status === 202 || response.status === 200) {
        setKlaviyoReminderState(button, 'success');
        return;
      }

      let errorPayload = null;
      let errorText = '';

      try {
        errorPayload = await response.json();
      } catch (jsonError) {
        try {
          errorText = await response.text();
        } catch (textError) {
          errorText = '';
        }
      }

      if (isKlaviyoAlreadySubscribedError(errorPayload, errorText)) {
        setKlaviyoReminderState(button, 'success');
        return;
      }

      const apiErrorMessage = getKlaviyoApiErrorMessage(response, errorPayload, errorText);
      console.warn('Klaviyo Back in Stock request failed.', {
        status: response.status,
        message: apiErrorMessage,
        payload: errorPayload || errorText,
        variantId,
        customerEmail,
        companyId: apiKey
      });
      setKlaviyoReminderState(button, 'error', apiErrorMessage);
    } catch (error) {
      console.warn(error);
      setKlaviyoReminderState(button, 'error', error && error.message ? `Klaviyo Back in Stock network error: ${error.message}` : 'Klaviyo Back in Stock network error.');
    }
  }

  document.addEventListener('click', function (event) {
    if (locationMenu && !locationMenu.contains(event.target)) {
      closeLocationMenu();
    }

    const cartLink = event.target.closest('a[href]');

    if (
      cartLink &&
      !cartPage &&
      /\/cart(?:$|[?#])/.test(new URL(cartLink.href, window.location.origin).pathname) &&
      (
        Object.keys(pendingCartUpdates).length > 0 ||
        Object.keys(readStoredPendingCartUpdates()).length > 0 ||
        Boolean(cartSyncPromise)
      )
    ) {
      event.preventDefault();

      const destination = cartLink.href;
      cartLink.classList.add('is-loading');
      cartLink.setAttribute('aria-busy', 'true');

      forceFlushPendingCartUpdates()
        .then(function () {
          window.location.href = destination;
        })
        .catch(function () {
          cartLink.classList.remove('is-loading');
          cartLink.removeAttribute('aria-busy');
        });

      return;
    }

    const galleryButton = event.target.closest('[data-b2b-gallery-open]');

    if (galleryButton) {
      event.preventDefault();

      const title = galleryButton.dataset.galleryTitle || '';
      const images = (galleryButton.dataset.galleryImages || '')
        .split('||')
        .map((item) => item.trim())
        .filter(Boolean);

      openGallery(title, images);
      return;
    }

    const galleryClose = event.target.closest('[data-b2b-gallery-close]');

    if (galleryClose) {
      event.preventDefault();
      closeGallery();
      return;
    }

    const galleryModal = event.target.closest('[data-b2b-gallery-modal]');

    if (galleryModal && event.target === galleryModal) {
      closeGallery();
      return;
    }

    const directLocationLink = event.target.closest('[data-b2b-location-direct-link]');

    if (directLocationLink) {
      event.preventDefault();

      try {
        window.location.href = buildLocationSwitchUrl(directLocationLink.href);
      } catch (error) {
        window.location.href = directLocationLink.href;
      }

      return;
    }

    // Do not block cart navigation while background sync is pending.
    // The cart page will complete any stored pending sync on load.

    const remindButton = event.target.closest('[data-b2b-remind]');

    if (remindButton) {
      event.preventDefault();
      subscribeToKlaviyoBackInStock(remindButton);
      return;
    }

    const reorderButton = event.target.closest('[data-b2b-reorder]');

if (reorderButton) {
  event.preventDefault();
  handleReorder(reorderButton);
  return;
}

    const plusButton = event.target.closest('[data-b2b-plus]');
    const minusButton = event.target.closest('[data-b2b-minus]');

    if (plusButton || minusButton) {
      const row = event.target.closest('[data-b2b-product]');
      if (!row) return;

      handleStepper(row, plusButton ? 'plus' : 'minus');
      return;
    }

    const pill = event.target.closest('[data-b2b-pill]');

    if (pill) {
      const action = pill.dataset.b2bPillAction;
      const target = pill.dataset.b2bPillTarget;

      pausePillSyncUntil = Date.now() + 900;
      setActivePill(pill);

      if (action === 'all') {
        activeStockOnly = false;
        resetColorFilter();

        if (searchInput) {
          searchInput.value = '';
        }

        applyFilters();

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        return;
      }

      if (action === 'stock') {
        activeStockOnly = true;
        resetColorFilter();
        applyFilters();

        window.setTimeout(function () {
          scrollToFirstVisibleCategory();
        }, 50);

        return;
      }

      if (action === 'scroll') {
        activeStockOnly = false;
        resetColorFilter();
        applyFilters();

        window.setTimeout(function () {
          scrollToAnchor(target);
        }, 50);

        return;
      }
    }

    const colorButton = event.target.closest('[data-b2b-color-filter]');

    if (colorButton) {
      const selectedColor = colorButton.dataset.b2bColorFilter;
      const selectedCategory = colorButton.dataset.b2bColorCategory;
      const alreadyActive = colorButton.classList.contains('is-active');

      colorButtons.forEach((button) => {
        button.classList.remove('is-active');
      });

      if (alreadyActive) {
        activeColor = 'all';
        activeColorCategory = 'all';
      } else {
        colorButton.classList.add('is-active');
        activeColor = selectedColor;
        activeColorCategory = selectedCategory;
      }

      applyFilters();
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-b2b-qty]');

    if (input) {
      handleManualQuantity(input);
    }
  });

  document.addEventListener(
    'blur',
    function (event) {
      const input = event.target.closest('[data-b2b-qty]');

      if (input) {
        handleManualQuantity(input);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeLocationMenu();
      closeGallery();
    }

    if (event.key === 'Enter') {
      const input = event.target.closest('[data-b2b-qty]');

      if (input) {
        event.preventDefault();
        input.blur();
      }
    }
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      activeStockOnly = false;
      resetColorFilter();
      applyFilters();
    });
  }

  document.addEventListener('b2b:cart:changed', function (event) {
    const cart = event && event.detail ? event.detail.cart : null;

    if (cart && Array.isArray(cart.items)) {
      indexCart(cart);
    }
  });

  let scrollTicking = false;

  window.addEventListener('scroll', function () {
    if (scrollTicking) return;

    window.requestAnimationFrame(function () {
      syncActivePillSimple();
      scrollTicking = false;
    });

    scrollTicking = true;
  });

  window.addEventListener('resize', updateStickyHeights);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      refreshCart();
    }
  });

  function isDeliverySlotTrigger(trigger) {
    if (!trigger) return false;

    const deliverySelector = [
      '[data-b2b-delivery]',
      '[data-delivery]',
      '[data-delivery-method]',
      '[data-delivery-slot]',
      '[data-slot]',
      '[data-shipping-method]',
      '.b2b-delivery',
      '.delivery-method',
      '.delivery-slot',
      '.shipping-method'
    ].join(',');

    if (trigger.closest(deliverySelector)) {
      return true;
    }

    const label = (
      trigger.textContent ||
      trigger.value ||
      trigger.getAttribute('aria-label') ||
      ''
    ).toLowerCase();

    return (
      label.includes('choose delivery') ||
      label.includes('delivery method') ||
      label.includes('delivery slot') ||
      label.includes('shipping method') ||
      label.includes('slot')
    );
  }

  function getCheckoutTrigger(target) {
    const explicitCheckoutButton = target.closest('[data-b2b-checkout-button]');

    if (explicitCheckoutButton) {
      return explicitCheckoutButton;
    }

    const trigger = target.closest('a[href], button, input[type="submit"]');

    if (!trigger) return null;
    if (trigger.closest('[data-b2b-location-menu]')) return null;
    if (isDeliverySlotTrigger(trigger)) return null;

    const href = trigger.getAttribute('href') || trigger.getAttribute('formaction') || '';

    if (href && href.indexOf('/checkout') !== -1) {
      return trigger;
    }

    const form = trigger.closest('form');

    if (form) {
      const formAction = form.getAttribute('action') || '';

      if (formAction.indexOf('/checkout') !== -1) {
        return trigger;
      }
    }

    return null;
  }
  function withB2BTimeout(promise, timeoutMs, message) {
    let timeoutId;

    const timeoutPromise = new Promise((_, reject) => {
      timeoutId = window.setTimeout(function () {
        reject(new Error(message || 'The cart update is taking too long. Please try again.'));
      }, timeoutMs || 12000);
    });

    return Promise.race([promise, timeoutPromise]).finally(function () {
      window.clearTimeout(timeoutId);
    });
  }

  async function prepareB2BCheckout(trigger) {
    const checkoutButton = trigger || cartCheckoutButton;
    const form = checkoutButton ? checkoutButton.closest('form') : b2bCheckoutForm;

    if (form && form.dataset.b2bSubmitting === 'true') {
      return;
    }

    if (b2bCheckoutForm && b2bCheckoutForm.dataset.b2bSubmitting === 'true') {
      return;
    }

    const baseAttributes = getB2BAttributes();
    const formAttributes = getCheckoutFormAttributes(form || b2bCheckoutForm);
    const attributes = {
      ...(baseAttributes || {}),
      ...formAttributes
    };

    if (!attributes['B2B Company Location ID']) {
      alert('B2B company location is missing. Please go back to the catalog and try again.');
      return;
    }

    if (!attributes.Date || !attributes.Time) {
      document.dispatchEvent(new CustomEvent('b2b:delivery:open'));
      return;
    }

    if (form) {
      form.dataset.b2bSubmitting = 'true';
    }

    if (b2bCheckoutForm) {
      b2bCheckoutForm.dataset.b2bSubmitting = 'true';
    }

    if (checkoutButton) {
      checkoutButton.disabled = true;
      checkoutButton.classList.add('is-loading');
    }

    if (cartCheckoutButton && cartCheckoutButton !== checkoutButton) {
      cartCheckoutButton.disabled = true;
      cartCheckoutButton.classList.add('is-loading');
    }

    try {
      await withB2BTimeout(
        saveCartForCheckout(attributes),
        12000,
        'Cart details are still saving. Please tap checkout again in a moment.'
      );

      window.location.href = `${root}checkout`;
    } catch (error) {
      alert(error.message || 'Could not prepare checkout. Please try again.');

      if (form) {
        form.dataset.b2bSubmitting = 'false';
      }

      if (b2bCheckoutForm) {
        b2bCheckoutForm.dataset.b2bSubmitting = 'false';
      }

      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('is-loading');
      }

      if (cartCheckoutButton) {
        cartCheckoutButton.disabled = false;
        cartCheckoutButton.classList.remove('is-loading');
      }
    }
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;

    const checkoutTrigger = getCheckoutTrigger(event.target);

    if (!checkoutTrigger) return;

    event.preventDefault();
    prepareB2BCheckout(checkoutTrigger);
  });

  if (b2bCheckoutForm) {
    b2bCheckoutForm.addEventListener('submit', async function (event) {
      const submitter = event.submitter || cartCheckoutButton || b2bCheckoutForm;
      const action = b2bCheckoutForm.getAttribute('action') || '';
      const isDirectCheckoutForm =
        b2bCheckoutForm.dataset.b2bDirectCheckout === 'true' ||
        action.indexOf('/checkout') !== -1 ||
        getCheckoutTrigger(submitter);

      if (!isDirectCheckoutForm || isDeliverySlotTrigger(submitter)) {
        return;
      }

      event.preventDefault();
      prepareB2BCheckout(submitter);
    });
  }

  function resumePendingCartSyncOnPageLoad() {
    const hadStoredUpdates = mergeStoredPendingCartUpdates();

    if (!hadStoredUpdates) {
      return Promise.resolve(latestCartCache);
    }

    return flushPendingCartUpdates()
      .then(function (cart) {
        if (!cartPage || !cart || !Array.isArray(cart.items)) {
          return cart;
        }

        const renderedVariantIds = new Set(
          Array.from(document.querySelectorAll('[data-b2b-cart-line]'))
            .map((line) => String(line.dataset.variantId || ''))
            .filter(Boolean)
        );

        const hasMissingRenderedLine = cart.items.some((item) => {
          return (
            !isB2BBoxItem(item) &&
            Number(item.quantity || 0) > 0 &&
            !renderedVariantIds.has(String(item.variant_id))
          );
        });

        if (hasMissingRenderedLine) {
          window.location.reload();
        }

        return cart;
      })
      .catch(function (error) {
        console.warn(error);
        return null;
      });
  }

  window.addEventListener('load', function () {
    updateStickyHeights();
    syncActivePillSimple();
  });

  refreshCart().then(function () {
    return resumePendingCartSyncOnPageLoad();
  });

  applyFilters();
  updateStickyHeights();
  syncActivePillSimple();

window.requestAnimationFrame(function () {
  window.requestAnimationFrame(function () {
    finishB2BLoading();
  });
});
})();
